import { useMemo } from "react";
import { useBrandTheme } from "@/features/theme/hooks/useBrandTheme";
import type { ApiMenuItem } from "@/features/theme/types/brandTheme.type";
import { dedupeMenuItems } from "@/features/theme/utils/dedupeMenuItems";

const EMPTY_MENU: ApiMenuItem[] = [];

export const useMenuItems = (): ApiMenuItem[] => {
  const { brandTheme } = useBrandTheme();
  const menu = brandTheme?.menu;
  return useMemo(() => (menu ? dedupeMenuItems(menu) : EMPTY_MENU), [menu]);
};
